import { recordHubSupportConsoleLine } from "./installHubSupportConsoleCapture";
import {
  displaySlowRequestPath,
  friendlySlowRequestLabel,
  slowRequestElapsedSeconds,
} from "./slowRequestBanner";

function buildSlowRequestSupportPayload(
  path: string,
  startedAtMs: number,
  method: string,
  thresholdMs: number,
  nowMs: number,
  event: "slow_request" | "slow_request_settled",
  clientRequestId?: string,
): Record<string, unknown> {
  const elapsedSeconds = slowRequestElapsedSeconds(startedAtMs, nowMs);
  const pathDisplay = displaySlowRequestPath(path);
  const label = friendlySlowRequestLabel(path);
  const payload: Record<string, unknown> = {
    event,
    method,
    path: pathDisplay,
    elapsedSeconds,
    thresholdMs,
  };
  if (clientRequestId) {
    payload.clientRequestId = clientRequestId;
  }
  if (label) {
    payload.label = label;
  }
  return payload;
}

/** Record when a request crosses the slow threshold (banner shown). */
export function logSlowApiRequestStartedForSupport(
  path: string,
  startedAtMs: number,
  method: string,
  thresholdMs: number,
  nowMs = Date.now(),
  clientRequestId?: string,
): void {
  const payload = buildSlowRequestSupportPayload(
    path,
    startedAtMs,
    method,
    thresholdMs,
    nowMs,
    "slow_request",
    clientRequestId,
  );
  const message = `Hub request taking longer than usual (${payload.elapsedSeconds}s): ${method} ${payload.path}`;
  recordHubSupportConsoleLine("warn", payload);
  console.warn(message, payload);
}

/** Record when a slow request finishes so tickets show total duration. */
export function logSlowApiRequestSettledForSupport(
  path: string,
  startedAtMs: number,
  method: string,
  thresholdMs: number,
  nowMs = Date.now(),
  clientRequestId?: string,
): void {
  const payload = buildSlowRequestSupportPayload(
    path,
    startedAtMs,
    method,
    thresholdMs,
    nowMs,
    "slow_request_settled",
    clientRequestId,
  );
  const message = `Hub slow request finished (${payload.elapsedSeconds}s): ${method} ${payload.path}`;
  recordHubSupportConsoleLine("warn", payload);
  console.warn(message, payload);
}
